import { render, staticRenderFns } from "./DpgIncrement.vue?vue&type=template&id=44d5b725"
import script from "./DpgIncrement.vue?vue&type=script&lang=ts"
export * from "./DpgIncrement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports